// ABOUTME: MSAL authentication configuration for premium-market space
// ABOUTME: Uses Entra External ID for premium market authentication
import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object for premium market MSAL instance
export const premiumMsalConfig: Configuration = {
    auth: {
        authority: 'https://external-id.factorlabs.pl/52270bb2-ed98-4b79-9314-1af808682b4b',
        clientId: 'a2f31eae-52e3-45b0-b0b9-bc2803f2c2e0',
        redirectUri: window.location.origin + '/premium-market',
        knownAuthorities: ["https://external-id.factorlabs.pl"],
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

// Scopes for premium market id token
export const premiumLoginRequest: PopupRequest = {
    scopes: ["User.Read"],
};

// MS Graph API endpoints for premium market
export const premiumGraphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
